const ga4 = require('../../ga4/ga4');

/**
 * Função responsável por apagar o cookie que mantém o usuário na versão antiga
 */
function eraseCookie(name) {
  const host = window.location.host;

  // remove o app. do início do domínio
  const parts = host.split('.').slice(1);

  // junta o domínio novamente com o ponto inicial
  const domain = '.' + parts.join('.');

  document.cookie = name + '=; Max-Age=-99999999; domain=' + domain + '; path=/';
}


function init() {
  const button = $('.button-to-new-version');

  button.on('click', function () {
    eraseCookie('redesign_despesas_old_version');
    ga4.event('-expenses_redesignButton')(button);

    window.location.reload();
  });
}

module.exports = {
  init,
  url: /^\/despesas/
}
